export default __webpack_public_path__ + "static/media/artist-banner.1fde1721.png";